import { EC_PAPER_MAX_WORD } from '@src/constants/paper'
import {
  getLoggedIn,
  getPaidMember,
  getUserID,
  getUserRole,
} from '@src/state/auth/selectors'
import { RootState } from '@src/state/types'
import { getWordCount } from '@src/utils/wordCount'
import { PAGE_TYPES } from '../analytics/constants'
import { getPageNameFromPath } from '../analytics/helpers'
import { getPlainText } from '../document/selectors'
import { selectPartialPlagiarismFound } from '../workspace/selectors'
import { VIRTUALPAGEPATHS } from './definitions/constants'

export const getPageSubGroup = (state: RootState): string => {
  const { pathname } = state.router.location
  return getPageNameFromPath(pathname)
}

export const getGTMData = (state: RootState) => {
  const wordCount = state.document.editorState ? getWordCount(getPlainText(state)) : null
  let page = getPageSubGroup(state)
  if (page === PAGE_TYPES.EC_FORM && wordCount && wordCount > EC_PAPER_MAX_WORD) {
    page = PAGE_TYPES.EC_FORM_TOO_LONG
  }
  return {
    loggedIn: getLoggedIn(state) ? 'yes' : 'no',
    role: getUserRole(state),
    pageGroup: 'awt',
    uploadId: state.workspace.id || null,
    userID: getUserID(state) || 'not logged in',
    pageSubGroup: page,
    wfeRelease: process.env.REACT_APP_RELEASE_TAG || 'playground',
    wordCount,
  }
}

export const getFreemiumPlagData = (state: RootState) => ({
  freemiumPlagFound: getFreemiumPlagFound(state),
})
const getFreemiumPlagFound = (state: RootState) => {
  if (getPaidMember(state)) {
    return 'subscriber not freemium'
  } else if (selectPartialPlagiarismFound(state)) {
    return 'plag found'
  } else {
    return 'plag not found'
  }
}

export const eCVirtualPageMap = {
  [PAGE_TYPES.EC_FORM]: VIRTUALPAGEPATHS.EC_FORM,
  [PAGE_TYPES.EC_FORM_TOO_LONG]: VIRTUALPAGEPATHS.EC_TOO_LONG,
  [PAGE_TYPES.EC_IN_PROGRESS]: VIRTUALPAGEPATHS.EC_WAITING,
  [PAGE_TYPES.EC_SUCCESS]: VIRTUALPAGEPATHS.EC_SUCCESS,
  [PAGE_TYPES.EC_UPGRADE]: VIRTUALPAGEPATHS.EC_UPGRADE,
}



// WEBPACK FOOTER //
// ./src/state/gtm/helper.ts